export function getActiveVote(voteId, upVotes = [], downVotes = []){
	if (upVotes.indexOf(voteId) !== -1) {
		return "up";
	}
	if (downVotes.indexOf(voteId) !== -1) {
		return "down";
	}
	return null;
}
